/**
 * IMPORT CORE DI ANGULAR
 */

import { NgModule, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';

/**
 * IMPORT TERZE PARTI
 */

/**
 * IMPORT DELL'APPLICAZIONE
 */
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpErrorsInterceptor } from './shared/_interceptor/http-errors.interceptor';
import { MainModule } from './main/main.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { TokenInterceptor } from './shared/_interceptor/token.interceptor';
import { MetaModule, MetaLoader, MetaStaticLoader, PageTitlePositioning } from '@ngx-meta/core';
import { environment } from '../environments/environment';
import { CustomTranslateLoader } from './shared/custom-translate-loader';
import { TransferHttpResponseInterceptor } from './shared/_interceptor/transfer-http-response.interceptor';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';


export class CustomHammerConfig extends HammerGestureConfig  {}

export function metaFactory(translate: TranslateService): MetaLoader {
  return new MetaStaticLoader({
    callback: (key: string) => {
      return key ? translate.get(key) : null;
    },
    pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
    pageTitleSeparator: '',
    applicationName: '',
    defaults: {
      title: environment.appName,
      description: environment.appName
    }
  });
}

export function customLoaderFactory(http: HttpClient, platformId) {
  return new CustomTranslateLoader(http, platformId);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CoreModule,
    SharedModule,
    MainModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (customLoaderFactory),
        deps: [HttpClient, PLATFORM_ID]
      },
      useDefaultLang: true
    }),
    MetaModule.forRoot({
      provide: MetaLoader,
      useFactory: (metaFactory),
      deps: [TranslateService]
    }),
    AppRoutingModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TransferHttpResponseInterceptor,
      multi: true
    },
    {
      provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig 
    },
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
